import app from '$$app';
import { api } from '$$store/api';

const collection = new webix.DataCollection();

if (app.config.mode.isBase) {
  api.get('integrations/slack').then(response => {
    collection.parse(response.data);
  }).catch(() => {
    collection.parse([]);
  });
}

collection.getData = function () {
  return new Promise((resolve, reject) => {
    api.get('/integrations/slack')
      .then(result => {
        const data = result.data;

        collection.parse(data);
        const _data = collection.serialize();

        _data.forEach(element => {
          element.editMode = false;
        });

        resolve(_data);
      }).catch(err => {
        new Error(err);
      });
  });
};

collection.getDataFromCollection = function () {
  const _data = collection.serialize();

  _data.forEach(element => {
    element.editMode = false;
  });

  return _data;
};

collection.addConnection = function (data) {
  return new Promise((resolve, reject) => {
    api.post('/integrations/slack/addConnection', data)
      .then(data => {
        const result = data.data;

        if (data.status === 200) {
          collection.add(result.item);
        }
        resolve(result);
      }).catch(err => {
        new Error(err);
      });
  });
};

collection.editConnection = function (data) {
  return new Promise((resolve, reject) => {
    const itemId = data.channelProjectId;

    api.post('/integrations/slack/editConnection', data)
      .then(data => {
        const result = data.data;

        if (data.status === 200) {
          let cItem = collection.getItem(itemId);

          cItem = result.item;
          collection.updateItem(itemId, cItem);
        }
        resolve(result);
      }).catch(err => {
        new Error(err);
      });
  });
};

collection.removeConnection = function (data) {
  return new Promise((resolve, reject) => {
    api.delete('/integrations/slack', { data })
      .then(data => {
        const result = data.data;

        if (data.status === 200) {
          collection.remove(result.id);
        }
        resolve(result);
      })
      .catch(err => {
        new Error(err);
      });
  });
};

collection.removeAllConnections = () => collection.clearAll();

collection.saveSetting = function (data) {
  return new Promise((resolve, reject) => {
    api.post('/integrations/slack/saveSetting', data)
      .then(response => {
        const result = response.data;

        if (response.status === 200) {
          const cItem = collection.getItem(data.id);

          cItem[data.settingType] = data.value;
          collection.updateItem(data.id, cItem);
        }
        resolve(result);
      }).catch(err => {
        new Error(err);
      });
  });
};

collection.getChannels = function () {
  return new Promise((resolve, reject) => {
    api.post('/integrations/slack/getConversions', {})
      .then(data => {
        const result = data.data;

        resolve(result.channels);
      }).catch(err => {
        new Error(err);
      });
  });
};

collection.attachEvent('onAfterAdd', id => {
  app.trigger('integration:slack:updated');
  app.trigger('integration:slack:addNewItem');
});

collection.attachEvent('onDataUpdate', id => {
  app.trigger('integration:slack:updated');
});

collection.attachEvent('onAfterDelete', id => {
  app.trigger('integration:slack:updated');
});

export default collection;
